module.exports = __webpack_public_path__ + "img/On Juhu Beach.7096fe07.jpg";